/* Match each bundle thumbnail to the chosen product color and bundle option. */
(() => {
  const selector = 'variant-selects[data-quantity-breaks-picker-displayed-images="variant_images"]';
  const attached = new WeakSet();
  const urlOf = variant =>
    variant?.featured_image?.src || variant?.featured_media?.preview_image?.src || '';

  function refresh(picker) {
    const data = picker.querySelector('script[type="application/json"]');
    if (!data) return;
    let variants;
    try { variants = JSON.parse(data.textContent); } catch { return; }
    if (!Array.isArray(variants)) return;

    const options = [...picker.children].filter(node =>
      node.classList.contains('product-form__input')
    );
    const values = options.map(node =>
      (node.querySelector('input[type="radio"]:checked') || node.querySelector('select'))?.value
    );
    const colors = options.flatMap((node, index) =>
      node.classList.contains('product-form__input--swatches') ? [index] : []
    );

    options.forEach((option, index) => {
      if (!option.classList.contains('product-form__input--quantity-breaks')) return;
      const choices = [...option.querySelectorAll('input[type="radio"]')];
      option.querySelectorAll('label.quantity-break[for]').forEach(label => {
        const input = choices.find(item => item.id === label.htmlFor);
        if (!input) return;
        const selected = values.slice();
        selected[index] = input.value;
        let match = variants.find(variant =>
          selected.every((value, i) => value != null && variant.options[i] === value)
        );
        let url = urlOf(match);
        if (!url && colors.length) {
          match = variants.find(variant =>
            colors.every(i => selected[i] != null && variant.options[i] === selected[i]) &&
            variant.options[index] === input.value && urlOf(variant)
          ) || variants.find(variant =>
            colors.every(i => selected[i] != null && variant.options[i] === selected[i]) &&
            urlOf(variant)
          );
          url = urlOf(match);
        }
        let holder = label.querySelector('.quantity-break__image');
        if (!url) {
          if (holder) holder.hidden = true;
          return;
        }
        if (!holder) {
          const container = label.querySelector('.quantity-break__image-and-content');
          if (!container) return;
          holder = document.createElement('div');
          holder.className = 'quantity-break__image';
          container.prepend(holder);
        }
        let image = holder.querySelector('img');
        if (!image) {
          image = document.createElement('img');
          image.loading = 'lazy';
          holder.append(image);
        }
        holder.hidden = false;
        if (image.getAttribute('src') !== url) image.setAttribute('src', url);
        if (image.hasAttribute('srcset')) image.removeAttribute('srcset');
        if (image.hasAttribute('sizes')) image.removeAttribute('sizes');
        const alt = selected.filter(Boolean).join(' / ');
        if (image.alt !== alt) image.alt = alt;
      });
    });
  }

  function watch(picker) {
    if (attached.has(picker)) return;
    attached.add(picker);
    let pending = false;
    const schedule = () => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => {
        pending = false;
        if (picker.isConnected) refresh(picker);
      });
    };
    picker.addEventListener('change', schedule);
    new MutationObserver(schedule).observe(picker, {
      subtree: true, childList: true, attributes: true,
      attributeFilter: ['src', 'srcset', 'sizes', 'checked']
    });
    schedule();
  }

  function scan(root) {
    if (root.matches?.(selector)) watch(root);
    root.querySelectorAll?.(selector).forEach(watch);
  }
  function boot() {
    scan(document);
    new MutationObserver(records => records.forEach(record =>
      record.addedNodes.forEach(node => { if (node.nodeType === 1) scan(node); })
    )).observe(document.documentElement, { subtree: true, childList: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
